<template>
    <div class="carBox" @mouseup="handleMouseUp">
        <el-card ref="left_tree" class="box-card" style="height: calc(100vh - 152px);width: 200px;overflow-y: auto">
            <el-tree :data="orgData" @node-click="clickOrg" default-expand-all :expand-on-click-node="false"></el-tree>
        </el-card>
        <div ref="resizeHandle" class="handle-resize" />
        <div ref="moveDiv" class="handle-resize-h" />
        <el-card ref="right_content" class="box-card" style="width: calc(100% - 210px);">
            <div class="mainBody">
                <div class="searchBox">
                    <div class="searchGroup">
                        <label>用户名：</label>
                        <el-input v-model="search_Obj.f_username" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>姓名：</label>
                        <el-input v-model="search_Obj.f_realname" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column prop="username" label="用户名" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="realname" label="姓名" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="online_time_str" label="在线时长" sortable="custom"></el-table-column>
                        <el-table-column prop="ocr_count" label="OCR识别数量" sortable="custom"></el-table-column>
                        <el-table-column prop="import_report_count" label="导入报告数量" sortable="custom"></el-table-column>
                        <el-table-column prop="deal_report_check_count" label="处置监测报告数量" sortable="custom"></el-table-column>
                        <el-table-column prop="deal_report_extract_count" label="处置抽检报告数量" sortable="custom"></el-table-column>
                        <el-table-column prop="check_device_count" label="巡检设备数量" sortable="custom"></el-table-column>
                        <el-table-column prop="update_time" label="数据更新时间" sortable="custom"></el-table-column>
                        <el-table-column label="操作" width="120" align="center">
                            <template slot-scope="scope">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <Info
                    width="600px"
                    :id="model_id"
                    title="查看人员工作监控"
                    :isshow="infoshow"
                    @on-close="closeInfoDialog">
                </Info>
                <LogList
                    width="1400px"
                    :user_id="model_id"
                    title="查看人员工作监控"
                    :isshow="editshow"
                    @on-close="closeEditDialog">
                </LogList>
            </div>
        </el-card>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Info from "./info"
import LogList from "./loglist"
import listutil from "@/libs/listutil"
import { getOrgTreeData } from '@/api/org'
import { exportUserMonitor } from '@/api/usermonitor'

export default {
    name: 'userMonitorList',
    mixins: [listutil],
    components: { Info, LogList, Btns, LabBtns},
    data() {
        return {
            m_name: '人员工作监控',
            menu_id: 1140,
            list_url: "/api/admin/usermonitor/list",
            search_Obj: {
                f_username: '',
                f_realname: '',
                org_id: '',
            },
            del_Obj:{
                url:'/api/admin/usermonitor/del',
                data:{
                    ids:''
                }
            },
            orgData: [],
            enu_name: [],
        };
    },
    mounted(){
        this.dragControllerDiv(this.$refs.left_tree.$el, this.$refs.resizeHandle, this.$refs.moveDiv)
    },
    methods: {
        loadOtherData() {
            this.orgData = []
            getOrgTreeData().then(res=>{
                if(res.code ==1){
                    var treeData = res.data
                    treeData = this.removeEmptyChild(treeData)
                    this.orgData = treeData
                }
            })
        },
        clickOrg(data){
            this.search_Obj.org_id = data.id
            this.getListData()
        },
        info(index, row) {
            this.model_id = row.user_id
            this.editshow = true
        },
        export(){
            exportUserMonitor(this.search_Obj.org_id, this.search_Obj.f_username, this.search_Obj.f_realname).then(res=>{
                if(res.code == 1){
                    window.open(res.data)
                }else{
                    this.$msg(res.msg)
                }
            })
        },
    }
};
</script>